import { getSavedItems } from "./getSavedItems";
import { INITIAL_ITEM_OFFSET, BATCH_SIZE, RECEIVE_ITEMS } from "../constants";

export const getSavedItemsResetFromStart =
  ({ retryBackoffs }) =>
  async dispatch => {
    const savedItems = await dispatch(
      getSavedItems({
        retryBackoffs,
        offset: INITIAL_ITEM_OFFSET,
        limit: BATCH_SIZE * 2,
        cancelInFlight: true
      })
    );

    if (savedItems === null) {
      return null;
    }

    dispatch({
      type: RECEIVE_ITEMS,
      payload: {
        savedItems
      }
    });

    return savedItems;
  };
